import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'data': 'String!'
};

export default gql(`
	mutation qrcode( ${ HelperGraphql.createFields( fields ) } ) {
	    qrcode( ${ HelperGraphql.createVariables( fields ) } ) {
	       guid
	       data
	       active
	    }
	}
`);

